const ReferenceLetter = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="currentColor"
            d="M5.825 13.775h7.65l1.5-1.5h-9.15v1.5Zm0-4h5.5v-1.5h-5.5v1.5Zm-2.25-3.75v10h7.65l-1.5 1.5h-7.65v-13h19v3.15h-1.5v-1.65h-16ZM21.8 11.15a.382.382 0 0 1 .125.275c0 .084-.042.167-.125.25l-.85.825-1.25-1.274.825-.826c.083-.083.167-.125.25-.125.1 0 .192.042.275.125l.75.75Zm-9.075 8.325v-1.25l6.375-6.4 1.275 1.276L14 19.474h-1.275Zm-9.15-13.45v10-10Z"
        />
    </svg>
);

export default ReferenceLetter;
